<template>
  <div class="mcontainer">
    <div class="hero-slider-admin">
      <div class="header-section">
        <div class="header-content">
          <div class="header-icon-wrap">
            <Icon icon="bx:image-alt" width="28" height="28" />
          </div>
          <div>
            <h1 class="page-title" style="color: white;">Hero Slider Feed</h1>
            <p class="page-subtitle">Kelola slide banner di halaman Feed</p>
          </div>
        </div>
        <button class="btn-create" @click="openAdd">
          <Icon icon="mdi:plus" width="20" height="20" />
          <span>Tambah Slide</span>
        </button>
      </div>

      <div class="card-panel">
        <div v-if="loading" class="loading-state">
          <b-spinner />
          <p>Memuat data...</p>
        </div>

        <div v-else-if="slides.length === 0" class="empty-state">
          <Icon icon="bx:image-alt" width="48" height="48" />
          <p>Belum ada slide. Tambahkan slide pertama!</p>
          <button class="btn-create" @click="openAdd">
            <Icon icon="mdi:plus" width="18" height="18" />
            Tambah Slide
          </button>
        </div>

        <div v-else class="slides-grid">
          <div v-for="(slide, idx) in slides" :key="slide.id" class="slide-card">
            <div class="slide-thumb">
              <img v-if="slide.background" :src="slide.background" :alt="slide.title">
              <div v-else class="thumb-placeholder">
                <Icon icon="bx:image-alt" width="32" height="32" />
              </div>
              <span class="slide-order">{{ idx + 1 }}</span>
            </div>
            <div class="slide-info">
              <h3 class="slide-title">{{ slide.title || '(Tanpa judul)' }}</h3>
              <p class="slide-desc">{{ slide.description || '—' }}</p>
              <p v-if="slide.link_button" class="slide-link">
                <Icon icon="mdi:link" width="14" />
                {{ slide.link_button }}
              </p>
            </div>
            <div class="slide-actions">
              <button class="action-btn action-edit" @click="openEdit(slide)">
                <Icon icon="mdi:pencil" width="16" />
                Edit
              </button>
              <button class="action-btn action-delete" @click="confirmDelete(slide)">
                <Icon icon="mdi:trash-outline" width="16" />
                Hapus
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Add/Edit -->
    <b-modal
      v-model="modal.show"
      :title="modal.isEdit ? 'Edit Slide' : 'Tambah Slide'"
      size="lg"
      :hide-footer="true"
      @hidden="resetForm"
    >
      <form @submit.prevent="submitForm">
        <div class="modal-section">
          <label class="modal-label">Gambar Background *</label>
          <div class="image-uploader" @click="$refs.bgInput.click()">
            <input type="file" ref="bgInput" accept="image/*" @change="onImageSelected" style="display:none">
            <img v-if="form.previewImage" :src="form.previewImage" class="preview-img" alt="preview">
            <div v-else class="upload-placeholder">
              <Icon icon="bi:cloud-upload" width="32" height="32" />
              <span>Klik untuk pilih gambar</span>
              <span class="upload-hint">Rekomendasi: 1200×400px, maks 5MB</span>
            </div>
          </div>
        </div>

        <div class="modal-grid">
          <div class="modal-section">
            <label class="modal-label">Judul</label>
            <input class="modal-input" v-model="form.title" type="text" placeholder="Judul slide">
          </div>
          <div class="modal-section">
            <label class="modal-label">URL Tombol / Link</label>
            <input class="modal-input" v-model="form.link_button" type="text" placeholder="https://...">
          </div>
        </div>

        <div class="modal-section">
          <label class="modal-label">Deskripsi</label>
          <textarea class="modal-input" v-model="form.description" rows="3" placeholder="Deskripsi singkat slide"></textarea>
        </div>

        <div class="modal-footer-btn">
          <button type="button" class="btn-cancel" @click="modal.show = false">Batal</button>
          <button type="submit" class="btn-submit" :disabled="submitting">
            <b-spinner v-if="submitting" small />
            <span v-else>{{ modal.isEdit ? 'Simpan Perubahan' : 'Tambah Slide' }}</span>
          </button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { Icon } from '@iconify/vue2'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'HeroSliderAdmin',
  components: { Icon },
  data () {
    return {
      submitting: false,
      modal: {
        show: false,
        isEdit: false
      },
      form: {
        id: null,
        background: null,
        previewImage: '',
        title: '',
        description: '',
        link_button: ''
      }
    }
  },
  computed: {
    ...mapState('carousel', ['data', 'loading']),
    slides () {
      return this.data || []
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    ...mapActions('carousel', ['fetch', 'create', 'update', 'delete']),
    openAdd () {
      this.resetForm()
      this.modal.isEdit = false
      this.modal.show = true
    },
    openEdit (slide) {
      this.form.id = slide.id
      this.form.previewImage = slide.background || ''
      this.form.background = null
      this.form.title = slide.title || ''
      this.form.description = slide.description || ''
      this.form.link_button = slide.link_button || ''
      this.modal.isEdit = true
      this.modal.show = true
    },
    resetForm () {
      this.form = { id: null, background: null, previewImage: '', title: '', description: '', link_button: '' }
      if (this.$refs.bgInput) this.$refs.bgInput.value = ''
    },
    onImageSelected (e) {
      const file = e.target.files[0]
      if (!file) return
      this.form.background = file
      this.form.previewImage = URL.createObjectURL(file)
    },
    async submitForm () {
      if (!this.form.previewImage && !this.form.background) {
        this.$swal({ icon: 'error', title: 'Error', text: 'Gambar background wajib dipilih' })
        return
      }
      this.submitting = true
      try {
        const payload = {
          title: this.form.title,
          description: this.form.description,
          link_button: this.form.link_button,
          facebook: '',
          linkedin: '',
          instagram: '',
          twitter: '',
          whatsapp: ''
        }
        if (this.form.background instanceof File) {
          payload.background = this.form.background
        }

        if (this.modal.isEdit) {
          await this.update({ id: this.form.id, data: payload })
          this.$swal({ icon: 'success', title: 'Berhasil', text: 'Slide berhasil diupdate' })
        } else {
          await this.create(payload)
          this.$swal({ icon: 'success', title: 'Berhasil', text: 'Slide berhasil ditambahkan' })
        }
        this.modal.show = false
        this.fetch()
      } catch (e) {
        const msg = e.response?.data?.message || 'Gagal menyimpan slide'
        this.$swal({ icon: 'error', title: 'Gagal', text: msg })
      } finally {
        this.submitting = false
      }
    },
    confirmDelete (slide) {
      this.$swal({
        title: 'Hapus slide ini?',
        text: `"${slide.title || 'Slide'}" akan dihapus permanen`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya, hapus',
        cancelButtonText: 'Batal'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await this.delete(slide.id)
            this.$swal({ icon: 'success', title: 'Berhasil', text: 'Slide berhasil dihapus' })
            this.fetch()
          } catch (e) {
            this.$swal({ icon: 'error', title: 'Gagal', text: 'Gagal menghapus slide' })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.hero-slider-admin { padding: 0; }

.header-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
  padding: 20px 24px;
  background: linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%);
  border-radius: 16px;
  color: #fff;
  box-shadow: 0 4px 20px rgba(139, 92, 246, 0.35);
}

.header-content { display: flex; align-items: center; gap: 16px; }

.header-icon-wrap {
  width: 52px; height: 52px;
  display: flex; align-items: center; justify-content: center;
  background: rgba(255,255,255,0.2);
  border-radius: 14px;
  backdrop-filter: blur(8px);
}

.page-title { margin: 0; font-size: 22px; font-weight: 700; }
.page-subtitle { margin: 4px 0 0; font-size: 14px; opacity: 0.9; }

.btn-create {
  display: inline-flex; align-items: center; gap: 8px;
  height: 42px; padding: 0 20px;
  background: #fff; color: #6d28d9;
  font-weight: 600; font-size: 14px;
  border-radius: 12px; border: none; cursor: pointer;
  text-decoration: none; transition: all 0.2s;
}
.btn-create:hover { background: #f5f3ff; transform: translateY(-1px); }

.card-panel {
  background: #fff;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  overflow: hidden;
  min-height: 200px;
}

.loading-state, .empty-state {
  display: flex; flex-direction: column;
  align-items: center; justify-content: center;
  gap: 12px; padding: 60px 24px;
  color: #94a3b8; text-align: center;
}
.empty-state p { margin: 0; font-size: 15px; font-weight: 500; }

.slides-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
  padding: 20px;
}

.slide-card {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  transition: box-shadow 0.2s;
}
.slide-card:hover { box-shadow: 0 4px 16px rgba(0,0,0,0.08); }

.slide-thumb {
  position: relative;
  height: 160px;
  background: #f1f5f9;
  overflow: hidden;
}
.slide-thumb img {
  width: 100%; height: 100%;
  object-fit: cover;
}
.thumb-placeholder {
  width: 100%; height: 100%;
  display: flex; align-items: center; justify-content: center;
  color: #cbd5e1;
}
.slide-order {
  position: absolute; top: 8px; left: 8px;
  width: 28px; height: 28px;
  background: rgba(0,0,0,0.6);
  color: #fff;
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 13px; font-weight: 700;
}

.slide-info { padding: 14px 16px; }
.slide-title { font-weight: 600; color: #1e293b; margin: 0 0 4px; font-size: 15px; }
.slide-desc { font-size: 13px; color: #64748b; margin: 0 0 6px; }
.slide-link {
  display: flex; align-items: center; gap: 4px;
  font-size: 12px; color: #6d28d9;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}

.slide-actions {
  display: flex; gap: 8px;
  padding: 10px 16px 14px;
  border-top: 1px solid #f1f5f9;
}

.action-btn {
  display: inline-flex; align-items: center; gap: 6px;
  height: 32px; padding: 0 12px;
  border: none; border-radius: 8px;
  font-size: 12px; font-weight: 500;
  cursor: pointer; transition: all 0.15s;
}
.action-edit { background: #ede9fe; color: #5b21b6; }
.action-edit:hover { background: #ddd6fe; }
.action-delete { background: #fee2e2; color: #b91c1c; }
.action-delete:hover { background: #fecaca; }

/* Modal */
.modal-section { margin-bottom: 16px; }
.modal-label {
  display: block; margin-bottom: 6px;
  font-size: 13px; font-weight: 600; color: #374151;
}
.modal-input {
  width: 100%; padding: 8px 12px;
  border: 1px solid #e5e7eb; border-radius: 8px;
  font-size: 14px; outline: none;
  transition: border-color 0.15s;
}
.modal-input:focus { border-color: #8b5cf6; }
.modal-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}
@media (max-width: 600px) { .modal-grid { grid-template-columns: 1fr; } }

.image-uploader {
  border: 2px dashed #d1d5db;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: border-color 0.15s;
  min-height: 160px;
  display: flex; align-items: center; justify-content: center;
}
.image-uploader:hover { border-color: #8b5cf6; }
.preview-img { width: 100%; max-height: 220px; object-fit: cover; display: block; }
.upload-placeholder {
  display: flex; flex-direction: column;
  align-items: center; gap: 8px;
  color: #9ca3af; padding: 32px;
  text-align: center;
}
.upload-hint { font-size: 12px; color: #d1d5db; }

.modal-footer-btn {
  display: flex; justify-content: flex-end; gap: 10px;
  padding-top: 16px; border-top: 1px solid #f1f5f9;
}
.btn-cancel {
  height: 38px; padding: 0 20px;
  background: #f1f5f9; color: #475569;
  border: none; border-radius: 8px;
  font-size: 14px; cursor: pointer;
}
.btn-cancel:hover { background: #e2e8f0; }
.btn-submit {
  height: 38px; padding: 0 24px;
  background: #6d28d9; color: #fff;
  border: none; border-radius: 8px;
  font-size: 14px; font-weight: 600; cursor: pointer;
  display: inline-flex; align-items: center; gap: 8px;
}
.btn-submit:hover { background: #5b21b6; }
.btn-submit:disabled { opacity: 0.7; cursor: not-allowed; }
</style>
